import type { MutableRefObject } from "react";
import { useRef } from "react";

export type InputRefType = MutableRefObject<HTMLInputElement>;

export const useInputRef = (): InputRefType =>
  useRef<HTMLInputElement>(document.createElement('input'));
